<template>
  <div class="logins xstart">
    <headers class="herderNav" ref="header" :isChange="false" />
    <div class="loginsCard">
      <div class="companyIcon"><img src="../assets/home/headerNav.png" /></div>

      <div class="logCard" v-if="loginText">
        <div class="cardCon">
          <h1>登录杀G工厂GMAT账号</h1>
          <div class="cardTit">
            <div class="titText">
              <h2
                v-for="(ele, index) in titText"
                :key="index"
                :class="n == ele.type ? 'active' : ''"
                @click="switchTab(ele.type)"
              >
                {{ ele.name }}
              </h2>
            </div>
            <!-- 验证码登陆 -->
            <div class="cardInput" v-if="iphoneCode">
              <div class="choiceRegion">
                <el-select v-model="selectDq" placeholder="+86(中国)">
                  <el-option label="+86(中国)" value="china"></el-option>
                  <el-option
                    label="+852(中国香港)"
                    value="shanghai"
                  ></el-option>
                  <el-option label="+853(中国澳门)" value="beijing"></el-option>
                </el-select>

                <input type="text" v-model="phoneCodes" />
              </div>
              <p class="nullNums" v-if="showPhone">{{ phoneTips.tipsOne }}</p>
              <div class="identCode">
                <input
                  type="text"
                  placeholder="输入手机验证码"
                  v-model="user.code"
                  @keyup.enter="goHome"
                />
                <button
                  @click="getCaptcha"
                  :disabled="flag"
                  :style="
                    !flag
                      ? 'background: #5191ff;color:white'
                      : 'background: #d2d2d2;color: #666'
                  "
                >
                  {{ content }}
                </button>
              </div>
              <p class="nullCode" v-if="showCode">{{ phoneTips.code }}</p>
              <p class="newPhone">新手机号将自动进入注册流程</p>
              <div class="remberPwd">
                <!-- <el-checkbox v-model="remberPwds">记住我</el-checkbox> -->
              </div>
            </div>
            <!-- 账号登录 -->
            <div class="cardInput" v-if="inphonePwd">
              <div class="choicePwds">
                <div class="choiceRegion">
                  <el-select v-model="selectDq" placeholder="+86(中国)">
                    <el-option label="+86(中国)" value="china"></el-option>
                    <el-option
                      label="+852(中国香港)"
                      value="shanghai"
                    ></el-option>
                    <el-option
                      label="+853(中国澳门)"
                      value="beijing"
                    ></el-option>
                  </el-select>
                  <!-- 账号文本框 -->
                  <input type="text" v-model="phoneCodesOne" />
                  <img
                    class="questIcons"
                    src="../assets/home/questionIcon.png"
                  />
                </div>
                <p class="nullNums" v-if="showPhonePwd">
                  {{ phoneTips.tipsTwo }}
                </p>
                <!-- 密码文本框 -->
                <el-input
                  class="pwdPhone"
                  placeholder="输入密码"
                  v-model="user.pwds"
                  show-password
                  @keyup.enter="goHomeTwo"
                ></el-input>
              </div>
              <p class="nullCode" v-if="showPwd">{{ phoneTips.codeTwo }}</p>
              <div class="remberPwd">
                <!--    -->
                <!--     记住我文本框 -->
                <el-checkbox style="font-size: 12px" v-model="remberPwds"
                  >记住我</el-checkbox
                >
                <div class="forgetPwd">
                  <a>忘记密码</a>
                  <img src="../assets/home/questionIcon.png" />
                </div>
              </div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="loginMethosBtn">
            <button @click="goHome" v-if="SignBtnOne">登录/注册</button>
            <button @click="goHomeTwo" v-if="SignBtn">登录</button>
            <div class="loginMethods">
              <div class="tipsInfos">
                <p>您还可以使用以下账号登录注册</p>
                <p></p>
              </div>
              <div class="loginChoiceMethods">
                <div
                  class="choiceMethods"
                  v-for="(item, indexs) in loginChoiceMethods"
                  :key="indexs"
                >
                  <a :href="href"><img :src="item.icon" /></a>
                  <span>{{ item.tit }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  二维码登录 -->
      <div class="codeLogin" v-if="codeLogins">
        <div id="login_container"></div>
        <p class="codeLoginTit">登录皮毛联盟GMAT</p>
        <p>微信扫码登录</p>
        <img src="../assets/code.png" />
        <h2 @click="switchLogin">切换其它登录/注册方式</h2>
      </div>
    </div>
  </div>
</template>
<script>
// 引入base64
const Base64 = require("js-base64").Base64;
import api from "../api/index.js";
import headers from "../components/header.vue";
import { sessionStorage } from "../api/sessionStorage.js";

export default {
  components: {
    headers,
    sessionStorage,
  },
  data() {
    return {
      href:
        "https://open.weixin.qq.com/connect/qrconnect?appid=wxd94f642532c50bef&redirect_uri=" +
        encodeURIComponent(window.location.href) +
        "&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect",
      // 验证码按钮
      flag: false, //按钮是否可取
      content: "获取验证码", //按钮内文本
      totalTime: 60, //倒计时时间
      navCodes: require("@/assets/login/navCode.png"),
      headerIcon: require("@/assets/home/headerNav.png"),
      herderTits: {
        color: "#666666",
      },
      //登录btn
      SignBtnOne: false,
      SignBtn: true,
      loginText: true, //文本框登录
      codeLogins: false, //二维码登录
      n: 0,
      iphoneCode: false, //手机验证码登录
      inphonePwd: true, //手机密码登录
      remberPwds: "", //记住密码
      //验证码 or 密码
      titText: [
        {
          name: "手机验证码登录",
          type: 1,
        },
        {
          name: "账号密码登录",
          type: 0,
        },
      ],
      loginChoiceMethods: [
        {
          icon: require("../assets/login/wx.png"),
          tit: "微信",
        },
      ],
      selectDq: "",
      //登录input 的值
      phoneCodes: "", //手机验证码登录  号码
      phoneCodesOne: "", //账号文本框
      user: {
        phone1: "",
        pwds: "", //密码文本框
        code: null,
      },
      //提示信息
      phoneTips: {
        tipsOne: "",
        tipsTwo: "",
        code: "",
        codeTwo: "",
      },
      showPhone: false, //手机号提示 验证码
      showCode: false, //手机验证码提示  验证码
      showPhonePwd: false, //手机号提示 密码
      showPwd: false, //手机号密码  密码
    };
  },
  created() {
    if (this.$route.query && this.$route.query.code) {
      this.wxqrcode(this.$route.query.code);
    }
    // 在页面加载时从cookie获取登录信息
    let account = this.getCookie("account");
    let password = Base64.decode(this.getCookie("password"));
    // 如果存在赋值给表单，并且将记住密码勾选
    if (account) {
      this.phoneCodesOne = account;
      this.user.pwds = password;
      this.remberPwds = true;
    }
  },

  methods: {
    wxqrcode(code) {
      api
        .wxqrcode({
          code: code,
        })
        .then((res) => {
          console.log("登录", res);
          if (res.data.code === 0) {
            localStorage.setItem("token", res.data.token);
            this.$router.push("home");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("登录失败，请重试");
        });
    },
    switchTab(type) {
      this.n = type;
      if (type == 1) {
        this.iphoneCode = this.SignBtnOne = true;
        this.inphonePwd = this.SignBtn = false;
        this.user.code = "";
      } else {
        this.iphoneCode = this.SignBtnOne = false;
        this.inphonePwd = this.SignBtn = true;
        this.user.pwds = "";
      }
    },

    //手机号码登录
    goHome() {
      if (this.phoneCodes && this.user.code) {
        const reg = /^1([0-9]\d|5[0-35-9]|7[3678])\d{8}$/;
        if (
          this.phoneCodes == "" ||
          this.phoneCodes.length < 10 ||
          !reg.test(this.phoneCodes)
        ) {
          this.phoneTips.tipsOne = "请输入正确的手机号";
          this.showPhone = true;
        } else {
          this.showPhone = this.showCode = false;
          this.goRouterHome();
        }
      } else {
        if (!this.phoneCodes) {
          this.showPhone = true;
          this.phoneTips.tipsOne = "手机号不能为空";
        }
        if (!this.user.code) {
          this.showCode = true;
          this.phoneTips.code = "手机验证码不能为空";
        }
      }
    },

    // 储存表单信息
    setUserInfo: function () {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.remberPwds) {
        this.setCookie("account", this.phoneCodesOne);
        // base64加密密码
        let passWord = Base64.encode(this.user.pwds);
        this.setCookie("remember", passWord);
      } else {
        this.setCookie("account", "");
        this.setCookie("password", "");
      }
    },
    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    // 保存cookie
    setCookie: function (cName, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },

    //账号密码登录
    goHomeTwo() {
      this.setUserInfo();
      if (this.phoneCodesOne && this.user.pwds) {
        const reg = /^1([0-9]\d|5[0-35-9]|7[3678])\d{8}$/;
        if (
          this.phoneCodesOne == "" ||
          this.phoneCodesOne.length < 10 ||
          !reg.test(this.phoneCodesOne)
        ) {
          this.phoneTips.tipsTwo = "请输入正确的手机号";
          this.showPhonePwd = true;
        } else {
          this.showPhonePwd = this.showPwd = false;
          this.getPwdLogin();
        }
      } else {
        if (!this.phoneCodes) {
          this.showPhonePwd = true;
          this.phoneTips.tipsTwo = "账号不能为空";
        }
        if (!this.user.codeTwo) {
          this.showPwd = true;
          this.phoneTips.codeTwo = "密码不能为空";
        }
      }
    },
    switchLogin() {
      this.$router.push("/?updata=1");
    },
    //登录接口  => 验证码登录
    goRouterHome() {
      let params = {
        phone: this.phoneCodes,
        code: this.user.code,
      };
      let query = this.$qs.stringify(params);
      api
        .getSign(query)
        .then((res) => {
          console.log("登录", res);
          if (res.data.code === 0) {
            localStorage.setItem("phone", this.phoneCodes);
            localStorage.setItem("token", res.data.token);
            this.$router.push("home");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("登录失败，请重试");
        });
    },
    //登录接口  => 密码登录
    getPwdLogin() {
      let params = {
        phone: this.phoneCodesOne,
        password: this.user.pwds,
      };
      let query = this.$qs.stringify(params);
      api
        .getLogPwd(query)
        .then((res) => {
          if (res.data.code === 0) {
            localStorage.setItem("phone", this.phoneCodesOne);
            localStorage.setItem("token", res.data.token);
            this.$router.push("home");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error("密码登录失败");
        });
    },
    //获取验证码 接口
    getCodes() {
      this.flag = true;
      let params = {
        phone: this.phoneCodes,
      };
      let query = this.$qs.stringify(params);
      api
        .getCode(query)
        .then((res) => {
          alert(res.data.data);
        })
        .catch((err) => {
          this.$message.error("验证码请求失败");
        });
    },
    //获取验证码
    getCaptcha() {
      const reg = /^1([0-9]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (
        this.phoneCodes == "" ||
        this.phoneCodes.length < 10 ||
        !reg.test(this.phoneCodes)
      ) {
        this.$message.error("手机号格式错误，请重试");
      } else {
        this.flag = false; //点击之后设置按钮不可取
        this.content = this.totalTime + "s后重新发送"; //按钮内文本
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.content = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.content = "重新发送验证码";
            this.totalTime = 60;
            this.flag = false; //这里重新开启
          }
        }, 1000);
        this.getCodes();
      }
    },
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
  },
  watch: {
    //手机验证码登录  号码
    phoneCodes(newVal, oldVal) {
      const reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (reg.test(newVal)) {
        this.showPhone = false;
      }
    },
    //手机验证码登录  密码
    phoneCodesOne(newVal, oldVal) {
      const reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (reg.test(newVal)) {
        this.showPhonePwd = false;
      }
    },
    //二维码登录 与 账号登录 （切换）
    $route: {
      handler() {
        if (this.$route.query.updata == 0) {
          this.codeLogins = true;
          this.loginText = false;
        } else {
          this.codeLogins = false;
          this.loginText = true;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
@import url("../assets/css/login.css");
</style>



// WEBPACK FOOTER //
// src/view/login.vue